import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent],
  template: `
    <div class="app-layout" [class.is-login]="isLoginPage()" [class.sidebar-collapsed]="sidebarCollapsed">
      <app-sidebar *ngIf="!isLoginPage()" 
        [collapsed]="sidebarCollapsed" 
        (collapsedChange)="sidebarCollapsed = $event">
      </app-sidebar>
      <main class="main-content" [class.no-sidebar]="isLoginPage()">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    .app-layout {
      display: flex;
      min-height: 100vh;
      background: var(--surface-bg);
    }

    .main-content {
      margin-left: 260px;
      flex: 1;
      min-height: 100vh;
      min-width: 0;
      width: calc(100vw - 260px);
      max-width: calc(100vw - 260px);
      overflow-x: hidden;
      transition: margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                  width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                  max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);

      &.no-sidebar {
        margin-left: 0 !important;
        width: 100vw;
        max-width: 100vw;
      }
    }

    .sidebar-collapsed .main-content {
      margin-left: 72px;
      width: calc(100vw - 72px);
      max-width: calc(100vw - 72px);
    }
  `]
})
export class AppComponent {
  private router = inject(Router);
  sidebarCollapsed = false;

  isLoginPage(): boolean {
    const url = this.router.url;
    if (url && url !== '/') {
      return url.includes('/login');
    }
    return typeof window !== 'undefined' && window.location.pathname.includes('/login');
  }
}
